<template>
  <div class="userInfo">
    <!-- 个人信息头部 -->
    <div class="header-content">
      <el-dropdown>
        <span class="el-dropdown-link">
          <div class="name">{{ userInfo.nickname||userInfo.username }}</div>
          <img :src="userInfo.avatar" class="img" alt="">
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="userInfo.mobile" @click.native="handleInfo">修改资料</el-dropdown-item>
		  <el-dropdown-item v-if="userInfo.mobile" @click.native="handlePhone">修改手机号</el-dropdown-item>
		  <el-dropdown-item v-if="userInfo.mobile" @click.native="handlepass">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data(){
    return{
      userInfo: {}
    }
  },
  mounted(){
    this.$nextTick(() => {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr);
      }
    })
  },
  methods:{
    // 个人信息
    handleInfo(){
      this.$router.push('/info');
    },
	// 手机号
	handlePhone(){
		this.$router.push('/phone');
	},
	//密码
	handlepass(){
		this.$router.push('/pass');
	},
    // 退出登录
    handleLogout(){
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      this.$router.push('/');
    }
  }
}
</script>

<style lang="scss" scoped>
.userInfo {
  background-color: #22bf76;
  height: 50px;
  width: 100%;
  
  .header-content {
    height: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    
    .el-dropdown-link {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .name {
      color: white;
      font-size: 16px;
      margin-right: 10px;
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
}
</style>
